import script from "./InfoIcon.vue?vue&type=script&setup=true&lang=js"
export * from "./InfoIcon.vue?vue&type=script&setup=true&lang=js"

import "./InfoIcon.vue?vue&type=style&index=0&id=a40edacc&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a40edacc"]])

export default __exports__